/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import Datetime from 'react-datetime';

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSCheckBox from "components/Forms/TSCheckBox";
import TSSelect2 from "components/Forms/TSSelect2";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";

import TSUser from "components/Forms/TSUser";
// import avatar from "assets/img/faces/marc.jpg";
import {
    Input,
    Label,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }]

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

// ย้าย moment มาไว้ข้างนอกเพื่อแก้ปัญหา dependency
var moment = require('moment');
require('moment/locale/th');

const Admin = (props) => {
    // ลบการประกาศ moment ในนี้ออก
    const [leaveAll, setLeaveAll] = useState([]);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    const [ArrLeave, setArrLeave] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [modal, setModal] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [optionYear, setOptionYear] = useState([]);
    const [year, setYear] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    // const [isShowCalendar, setIsShowCalendar] = useState(false);

    const myRef = useRef(null);
    var calendarRef = React.createRef();

    useEffect(() => {

        var startYear = parseInt(moment().format("BBBB"));
        if (moment().month() >= 9) {
            startYear = startYear + 1;
        }
        setYear(startYear);

        // แก้ไข: สร้าง array ชั่วคราวแทนการ push ใส่ state โดยตรง
        let tempOptionYear = [];
        for (var i = startYear + 1; i > startYear - 10; i--) {
            tempOptionYear.push({ value: i, label: i });
        }
        setOptionYear(tempOptionYear);
    }, [])


    useEffect(() => {
        setIsLoading(true);

        if (year > 0) {
            axios.get("/api/v1/service-request/serviceall/?Calyear=" + year)
                .then(
                    result => {
                        var json = JSON.parse(JSON.stringify(result.data).split('"leaveDesc":').join('"title":').split('"startDate":').join('"start":')
                            .split('"endDate":').join('"end":').split('"serviceRequestID":').join('"id":'));
                        if (json.length >= 0) {
                            setLeaveAll(json);
                            setIsLoading(false);
                        }
                    },
                    error => { alert(error); }
                );
        }

    }, [year]);


    const handleConfirm = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    };


    const handleDateClick = (args) => {
        setDefaultDate(args.dateStr);

    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))

    };


    const handleEventClickList = e => {
        // แก้ไข: != เป็น !==
        if (e.event._def.publicId !== null && e.event._def.publicId !== '') {
            props.history.push({
                pathname: 'id/' + e.event._def.publicId,
                //state: {
                //    meetingID: e.event._def.publicId
                //}
            })
        }

    }


    const classes = useStyles();
    return (

        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={6} sm={6} md={3}>
                                    <h4 className={classes.cardTitleWhite}>รายการขอใช้บริการทั้งหมด</h4>
                                </Col>

                                <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                                    {/* {isShowCalendar ? */}
                                    <TSSelect2
                                        options={optionYear}
                                        onChange={e => setYear(e.value)}
                                        value={year}
                                    //defaulfAdd={optionYear[0]}
                                    />
                                </Col>
                                {/* <Col xs={6} sm={6} md={3} style={{ textAlign: 'right' }}>
                                    <TSCheckBox checked={isShowCalendar} onChange={e => setIsShowCalendar(!isShowCalendar)} /> {(isShowCalendar) ? <span style={{ color: 'white' }} >แยกห้อง </span> : <span style={{ color: 'white' }}>รายการ </span>}
                                </Col> */}
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                {isLoading && (
                                    <>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <img style={{ width: "50%" }} src={loading} alt="..." />
                                        </Col>
                                    </>
                                )}
                                {!isLoading && (<>
                                    {(leaveAll.length > 0) && (
                                        <Col xs={12} sm={12} md={12} style={{ marginTop: "20px" }}>
                                            <div >
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>วันที่</th>
                                                            <th>รายละเอียด</th>
                                                            {/* <th>จำนวนวัน</th> */}
                                                            <th>สถานะ</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {

                                                            leaveAll.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td style={{ minWidth: '70px' }}>
                                                                        {moment(item.start).format('D MMM BB')}
                                                                    </td>
                                                                    <td>
                                                                        <a href={"id/" + item.id} >{item.title}</a>
                                                                    </td>
                                                                    {/* <td style={{ textAlign: 'center' }}>
                                                                        {item.totalDate} {item.isApprove}
                                                                    </td> */}
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {item.isCancel ? 'ยกเลิกแล้ว' :
                                                                            item.serviceApprove?.approveTypeKey === 4
                                                                            ? 'เตรียมข้อมูล' : item.serviceApprove?.approveTypeKey === 3 
                                                                            ? 'วิเคราะห์ข้อมูล' : item.serviceApprove?.approveTypeKey === 2
                                                                            ? 'ส่งผลการวิเคราะห์ให้ผู้วิจัย' :  item.serviceApprove?.approveTypeKey === 1
                                                                            ? 'อธิบายผลการวิเคราะห์ข้อมูล' 
                                                                            : '-'}
                                                                      
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>)}
                                </>)
                                }
                            </Grid>


                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
}

export default Admin;